/** 时间范围枚举 */
export enum TimeRange {
  /** 全部 */
  ALL = 'all',
  /** 近24小时 */
  HOURS_24 = '24h',
  /** 近7天 */
  DAYS_7 = '7d',
  /** 近30天 */
  DAYS_30 = '30d'
}

/** 区间对应的颗粒度 */
export const TimeGranularity = {
  /** 近24小时 */
  [TimeRange.HOURS_24]: 'hour',
 /** 近7天 */
 [TimeRange.DAYS_7]: 'day',
  /** 近30天 */
  [TimeRange.DAYS_30]: 'day',
}

/** 区间对应的时间格式 */
export const TimeFormat = {
  /** 近24小时 */
  [TimeRange.HOURS_24]: 'MM-DD HH:mm',
 /** 近7天 */
 [TimeRange.DAYS_7]: 'MM-DD',
  /** 近30天 */
  [TimeRange.DAYS_30]: 'MM-DD',
}
